var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome layerWarp"},[_c('div',{staticClass:"pageHeader"},[_c('p',[_vm._v("我的工作台")])]),_c('div',{staticClass:"layout-warp"},[_c('img',{attrs:{"src":require("../../../assets/images/login/welcome.png"),"alt":""}})])])
}]

export { render, staticRenderFns }